/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Constants for lifestyles module
 */

export const DONE_FETCHING_LIFESTYLES = '@@nzr/lifestyles/DONE_FETCHING_LIFESTYLES'
export const ERROR_FETCHING_LIFESTYLES = '@@nzr/lifestyles/ERROR_FETCHING_LIFESTYLES'
export const RECEIVE_LIFESTYLES = '@@nzr/lifestyles/RECEIVE_LIFESTYLES'
export const START_FETCHING_LIFESTYLES = '@@nzr/filters/START_FETCHING_LIFESTYLES'
